(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nativora-baukasten"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.nvMotion) return;
  window.nvMotion = 1;
  var d = document.documentElement;
  function off() { d.classList.remove('nv-anim'); }
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (d.classList.contains('nv-shot') || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window) || reduce) return;
    var vh = window.innerHeight;
    var els = [].slice.call(document.querySelectorAll('.nv .nv-rv'));
    els.forEach(function (el) { if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add('is-in'); });
    d.classList.add('nv-anim');
    var seen = false;
    var io = new IntersectionObserver(function (es) {
      seen = true;
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
    // Sicherheitsnetz: meldet der Observer sich bei sichtbarer Seite nicht, bleibt nichts versteckt.
    setTimeout(function () { if (!seen && document.visibilityState === 'visible') off(); }, 3000);
    var tls = [].slice.call(document.querySelectorAll('.nv [data-nv-tl]'));
    if (!tls.length) return;
    var live = [], tick = false;
    function draw() {
      tick = false;
      var a = window.innerHeight * 0.62;
      live.forEach(function (t) {
        [].forEach.call(t.querySelectorAll('.nv-tl__node'), function (n) {
          var mk = n.querySelector('.nv-tl__mark');
          if (!mk) return;
          var m = mk.getBoundingClientRect();
          n.classList.toggle('is-on', m.top + m.height / 2 <= a);
          var s = n.querySelector('.nv-tl__seg');
          if (s) {
            var nb = n.getBoundingClientRect().bottom, p = (a - m.bottom) / Math.max(1, nb - m.bottom);
            var q = Math.max(0, Math.min(1, p));
            s.style.setProperty('--p', q.toFixed(3));
            s.classList.toggle('is-run', q > 0 && q < 1);
          }
        });
      });
    }
    function req() { if (!tick) { tick = true; window.requestAnimationFrame(draw); } }
    var tio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var i = live.indexOf(e.target);
        if (e.isIntersecting && i < 0) live.push(e.target);
        if (!e.isIntersecting && i > -1) live.splice(i, 1);
      });
      draw();
    }, { rootMargin: '200px 0px' });
    tls.forEach(function (t) { tio.observe(t); });
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', off);
})();

  } catch(e) { console.error(e); }
})();
})();
